import { useTranslation } from "react-i18next";
import { ColumnLevelFilter } from "../../page/ProductsPage/ColumnLevelFilter";
import { useProductTypes } from "../../services/productsService";
import { useLocalizedProperty } from "../../utils";

export const ProductTypeFilter = (props) => {
    const { searchParams, setSearchParams } = props;
    const getLocalizedProperty = useLocalizedProperty();
    const { t } = useTranslation();

    const { data: productTypes } = useProductTypes();

    const productTypeOptions = productTypes || [];
    const columnValues = productTypeOptions.map((pt) => pt.name_eng);
    const columnDisplayValues = productTypeOptions.map((pt) => getLocalizedProperty(pt, "name"));

    return (
        <ColumnLevelFilter
            label={t("products.columns.productType")}
            columnValues={columnValues}
            columnDisplayValues={columnDisplayValues}
            columnName={"type"}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
        />
    );
};
